import React from 'react';

const EmailIcon = (props) => (
  <svg {...props} viewBox='0 0 16 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M13.6 0H2.4C1.76348 0 1.15303 0.252856 0.702944 0.702944C0.252856 1.15303 0 1.76348 0 2.4V10.4C0 11.0365 0.252856 11.647 0.702944 12.0971C1.15303 12.5471 1.76348 12.8 2.4 12.8H13.6C14.2365 12.8 14.847 12.5471 15.2971 12.0971C15.7471 11.647 16 11.0365 16 10.4V2.4C16 1.76348 15.7471 1.15303 15.2971 0.702944C14.847 0.252856 14.2365 0 13.6 0ZM13.272 1.6L8.568 6.304C8.49363 6.37898 8.40515 6.4385 8.30766 6.47911C8.21017 6.51973 8.10561 6.54064 8 6.54064C7.89439 6.54064 7.78983 6.51973 7.69234 6.47911C7.59485 6.4385 7.50637 6.37898 7.432 6.304L2.728 1.6H13.272ZM14.4 10.4C14.4 10.6122 14.3157 10.8157 14.1657 10.9657C14.0157 11.1157 13.8122 11.2 13.6 11.2H2.4C2.18783 11.2 1.98434 11.1157 1.83431 10.9657C1.68429 10.8157 1.6 10.6122 1.6 10.4V2.728L6.304 7.432C6.754 7.88144 7.364 8.13389 8 8.13389C8.636 8.13389 9.246 7.88144 9.696 7.432L14.4 2.728V10.4Z'
      fill={props.fill}
    />
  </svg>
);

export default EmailIcon;
